/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// 贷后还款等服务
import { RouteConfig } from 'vue-router';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { RouterV2Enum } from '../router-names';
import { tryBackPathOrHome } from '../utils';

export default (): RouteConfig[] => ([
  {
    path: RouterV2Enum.myApply,
    name: 'myApply',
    component: () => import(/* webpackChunkName: "repay" */ '@/views_v2/my-apply'),
    meta: {
      pageId: '臻有钱_我的提现页',
      title: '我的提现',
      isShowH5Nav: true,
      /** isShowCoffeeH5Nav配置为true是，isShowH5Nav也要配置为true */
      isShowCoffeeH5Nav: true,
      backPath: () => tryBackPathOrHome(RouterV2Enum.myProfile),
    },
  },

  {
    path: RouterV2Enum.applyDetails,
    name: 'applyDetails',
    component: () => import(/* webpackChunkName: "repay" */ '@/views_v2/apply-details'),
    meta: {
      pageId: 'finance_applyDetails',
      title: '提现详情',
    },
    props: (route) => ({
      orderId: String(route.query.loanId || ''),
      commodityId: String(route.query.commodityId || ''),
    }),
  },

  {
    path: RouterV2Enum.myBill,
    name: 'myBill',
    meta: {
      pageId: 'finance_myBill',
      title: '我的账单',
      newRedirect: NewVersionEnum.RepayBills,
      newRedirectReplace: false,
    },
    props: (route) => ({
      // 页面回退时，是否直接回退至首页
      isBackHome: route.query.isBackHome === 'true',
    }),
  },

  {
    path: RouterV2Enum.myBillAll,
    name: 'myBillAll',
    meta: {
      pageId: 'finance_myBillAll',
      title: '还款账单列表',
      newRedirect: NewVersionEnum.RepayPlans,
      newRedirectReplace: false,
    },
  },

  {
    path: RouterV2Enum.repayRecords,
    name: RouterV2Enum.repayRecords,
    props: (route) => ({
      loanOrderId: String(route.query.loanOrderId || ''),
    }),
    meta: {
      pageId: 'FinanceH5.RepayRecords',
      title: '还款记录',
      newRedirect: NewVersionEnum.RepayRecords,
      newRedirectReplace: false,
    },
  },
]);
